import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class VersionService {


  versions$: BehaviorSubject<any>;

  constructor(private http: HttpClient,
    private snackBar: MatSnackBar) { 
    this.versions$ = new BehaviorSubject(null);
  }

  loadVersions(accountId:number) {
    
    this.versions$.next({"loading":true,data:[]});

    let params = new HttpParams()
    .set('accountid', accountId.toString())

    this.http.get("/api/data/versions",{ params }).subscribe(
      (response: any) => {
        
        // add the dummy initial value
        let rtn = response;
        rtn.push({id:0,name:"Initial"})

        this.versions$.next({"loading":false,data:rtn});
      }, (error: any) => {
        // window.location.href = "/login"
        console.log('unable to get versions');
        console.log(error);
      }
    );
  }

  snapshotVersion(pdata:object){

    // put on the spinner
    let olddata = this.versions$.getValue().data;
    this.versions$.next({"loading":true,data:olddata});

    // turn the data object into form data to post
    let body = new HttpParams();
    Object.keys(pdata).forEach(x => {
      body = body.append(x,pdata[x]);
    })

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    this.http.post("/api/data/snapshotversions", body.toString(), {headers: headers})
    .subscribe(
      (response: any) => {

        if(response.success){
          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row
          const rtnid = response["id"];
          const rtndata = response["data"][0];

          let data = this.versions$.getValue().data;
          let found = false;

          data.forEach((x,i) => {
            if(x["id"]==rtnid){
              found = true;
              data[i] = rtndata;
            }
          });
          // the order if from last to first so add new ones at the start
          if(!found) data.unshift(rtndata);
         
          // publish the new data
          this.versions$.next({"loading":false, data:data});
          this.loadVersions(rtndata.accountid);
        }
      }, (error: any) => {
        let message="Unable to snaptshot the Version, you need to refresh page to continue"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        // setTimeout(() => {
        //   document.location.reload();
        // },1000)
      }
    );

  }
  
  updateVersion(pdata:object){

    // put on the spinner
    let olddata = this.versions$.getValue().data;
    this.versions$.next({"loading":true,data:olddata});

    // turn the data object into form data to post
    let body = new HttpParams();
    Object.keys(pdata).forEach(x => {
      body = body.append(x,pdata[x]);
    })

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    this.http.post("/api/data/versions", body.toString(), {headers: headers})
    .subscribe(
      (response: any) => {

        if(response.success){
          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row
          const rtnid = response["id"];
          const rtndata = response["data"][0];

          let data = this.versions$.getValue().data;
          let found = false;

          data.forEach((x,i) => {
            if(x["id"]==rtnid){
              found = true;
              data[i] = rtndata;
            }
          });

          // the order if from last to first so add new ones at the start
          if(!found) data.unshift(rtndata);
          
          // publish the new data
          this.versions$.next({"loading":false, data:data});

        }

      }, (error: any) => {
        let message="Unable to update the Version"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)
      }
    );

  }

  deleteVersion(data:object){

    // put on the spinner
    let olddata = this.versions$.getValue().data;
    this.versions$.next({"loading":true,data:olddata});

    // turn the data object into form data to post
    let body = new HttpParams().append("id",data["id"]).append("accountid",data["accountid"]);
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const options = {
      headers:headers,
      body: body
    }

    this.http.delete("/api/data/versions", options)
    .subscribe(
      (response: any) => {

        if(response.success){
          // get the id of the deleted row and remove that from the data
          const rtnid = response["id"];                  
          let data = this.versions$.getValue().data;
          data = data.filter(x => (x["id"] != rtnid));
        
          // publish the new data
          this.versions$.next({"loading":false,data:data});

        }

      }, (error: any) => {
        let message="Unable to delete the Version"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)
      }
    );

  }


}
